import React, { useState, useEffect, useCallback } from "react";
import Translation from "../../../common/translation/translation.component";
import { MODAL_CUSTOM_MESSAGE, TABLE_PAGINATION_KEY } from "../../../../constants/external-constants";
import { DetailsDashboard } from "../../../common/details-dashboard/details-dashboard-layout";
import { TablePagination } from "../../../common/details-table/table-pagination.component";
import { RequestHeaders } from "../../../common/header-logo/request-header.component";
import { NoSubscription } from "../../dashboard/no-subscription/no-subscription.component";
import { bindActionCreators } from "@reduxjs/toolkit";
import { LocationSiteAction } from "../../../../store/external/inventory/locationsite.reducer";
import { connect } from "react-redux";

const InventoryLocationsite = (props) => {
    const {
        fetchLocationSite,
        extractLocationSite,
        resizePageSize,
        applyLocationSiteFilter,
        addLocationSiteFilter,
        removeLocationSiteFilter,
        setLocationSiteColSearchStr,
        setLocationSiteColSort,
        saveInventoryLocationCustomCols,
        locationSite,
    } = props;

    const [displaySearch, setDisplaySearch] = useState(false);
    const [exportAlertMsg, setExportAlertMsg] = useState(MODAL_CUSTOM_MESSAGE.export_alert_message);
    const [headerTitle] = useState("LocationSite");
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        fetchLocationSite().finally(() => setIsLoading(false));

        return () =>{
            fetchLocationSite(0, true)
        }
    }, [fetchLocationSite]);

    const onClickExtract = useCallback(() => {
        if (window.confirm(exportAlertMsg)) {
            extractLocationSite();
        }
    }, [exportAlertMsg, extractLocationSite]);

    const displaySearchBox = useCallback(() => {
        setDisplaySearch((prev) => !prev);
    }, []);

    const resizePage = useCallback(
        (value) => {
            resizePageSize(value);
            fetchLocationSite();
        },
        [resizePageSize, fetchLocationSite]
    );

    const applyFilter = useCallback(
        (isApply) => {
            applyLocationSiteFilter(isApply);
            fetchLocationSite();
        },
        [applyLocationSiteFilter, fetchLocationSite]
    );

    const onChangeExtractAlertMsg = useCallback((val) => {
        setExportAlertMsg(val);
    }, []);

    const isReadAndWrite = true;

    const loading = () => <NoSubscription />;
    const { Selected, Available, Default } = locationSite.locationSite?.Columns || {};

    return (
        <div className="invoice-wrapper-container inventory-report-component">
            <Translation
                getOnlyText={true}
                onChangeTranslation={onChangeExtractAlertMsg}
                translationKey={"export_alert_message"}
            />
            <RequestHeaders headerTitle={headerTitle} />

            <div className={`request-table data-table fit-width`}>
                <DetailsDashboard
                    data={locationSite.locationSite.TableFilterData}
                    translation={""}
                    addAction={addLocationSiteFilter}
                    removeAction={removeLocationSiteFilter}
                    applyAction={applyFilter}
                    customClassName={TABLE_PAGINATION_KEY.locationSite}
                    createNewAction={() => { }}
                    viewSearchAction={displaySearchBox}
                    firstList={Available}
                    secondList={Selected}
                    defaultList={Default}
                    saveAction={saveInventoryLocationCustomCols}
                    extractAction={onClickExtract}
                    isReadAndWrite={isReadAndWrite}
                >
                    {isLoading ? (
                        loading()
                    ) : (
                        locationSite.locationSite && (
                            <TablePagination
                                key={TABLE_PAGINATION_KEY.locationSite}
                                tablePaginationKey={TABLE_PAGINATION_KEY.locationSite}
                                classNameWrapper="overflow-auto"
                                columns={locationSite.locationSite.Headers}
                                pageList={locationSite.locationSite.Data}
                                pages={locationSite.locationSite.Pagination}
                                rowClickAction={() => {} }
                                paginationAction={fetchLocationSite}
                                onColumnClick={setLocationSiteColSort}
                                onColumnSearch={() => fetchLocationSite(0)}
                                onColumnSearchChange={setLocationSiteColSearchStr}
                                isColSearchShow={displaySearch}
                                resizePage={resizePage}
                                totalPage={locationSite.locationSite.Pagination.TotalEntries || 0}
                                hideStatusIcon={false}
                            />
                        )
                    )}
                </DetailsDashboard>
            </div>
        </div>
    );
};

export default connect(
    (state) => {
        const { locationSite, attachFile } = state;
        return { locationSite, attachFile };
    },
    (dispatch) => bindActionCreators({ ...LocationSiteAction }, dispatch)
)(InventoryLocationsite);
